window.addEventListener('load', () => {
  const carrouselEquipe = new Swiper('.equipe__carrousel', {
    slidesPerView: 'auto',
    spaceBetween: 15,
    navigation: {
      nextEl: '.equipe__membres .swiper-button-next',
      prevEl: '.equipe__membres .swiper-button-prev',
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },

      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },

      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },

      1025: {
        slidesPerView: 'auto',
        spaceBetween: 15,
      },
    },
  });

  if (document.getElementById('equipe__video')) {
    const headerYT = new Plyr('#equipe__video', {
      controls: ['play-large', 'play', 'progress', 'volume', 'fullscreen'],
    });
  }

  const body = document.querySelector('body');
  const equipeItems = document.querySelectorAll('.equipe-item');
  const modal = document.querySelector('#modal');

  equipeItems.forEach((item) => {
    item.addEventListener('click', () => {
      // Set modal content
      modal.querySelector('.title').textContent =
        item.getAttribute('data-title');
      modal.querySelector('.equipe-item__details__poste').textContent =
        item.getAttribute('data-poste');
      modal.querySelector('.content-style').innerHTML = item.querySelector(
        '.description-detaillee'
      ).innerHTML;

      // Show modal
      modal.setAttribute('data-visible', 'true');

      // Disable body scrolling
      body.classList.add('no-scroll');
    });
  });

  document.querySelector('.modal__close').addEventListener('click', () => {
    // Hide modal
    modal.setAttribute('data-visible', '');

    // Enable body scrolling
    body.classList.remove('no-scroll');
  });

  // Check if modal is open and disable body scrolling
});
